import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { BemVindoRouterService } from './bem-vindo.routing.service';
import { BemVindoComponent } from './index.component';

const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild([ 
    { path: 'bem-vindo', component: BemVindoComponent }
]);

@NgModule({
    imports: [routing],
    exports: [RouterModule],
    providers: [BemVindoRouterService]
})
export class BemVindoRoutingModule { }
